export const MOBILE_MAX_WIDTH = 700;
export const TABLET_MAX_WIDTH = 1170;

export const MOBILE_UP = MOBILE_MAX_WIDTH + 1;
export const TABLET_UP = TABLET_MAX_WIDTH + 1;
